export const CODE_PUNTO_VENTA_TIPO_EMPRESA_375 = '05';
export const CODE_ESTADO_ANULADO_ORDEN_SERVICIO = '90';

//Responsabilidad fiscal
export const CODE_PERSONA_NATURAL_061 = 'PN';

export const CODE_TIPO_IDENTIFICACION_CEDULA_052 = '02';
export const CODE_TIPO_IDENTIFICACION_NIT_052 = '01';

export const CODE_ESTADO_BACKORDER_PENDIENTE_050 = '1';


// WEBPACK FOOTER //
// ./src/util/parametersConstants.js